import axios from 'axios';

// ================= api endpoints ====================
let user_auth_api = process.env.REACT_APP_USER_AUTH
let user_user_img = process.env.REACT_APP_USER_IMAGE
let api_domain = process.env.REACT_APP_API_DOMAIN
let api_users = process.env.REACT_APP_API_USERS

// ===============================  Check current user is available or not  ===============================
const check_current_user = (token, otherFunc) => {
    return (dispatch) => {
        // get token
        let storeData = localStorage.getItem("cyan_user");
        let userToken = storeData ? JSON.parse(storeData) : "null";
        // if token is available
        let userObj = { profileImg: {}, isAuth: false, isLoading: false }

        if (userToken !== "null" || token) {
            let headers = {
                'Authorization': `Token ${token || userToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            let user_data_url = user_auth_api;
            let user_profile_img = user_user_img;
            const getUserData = axios.get(user_data_url, {
                headers: headers
            });
            const getUserProfile = axios.get(user_profile_img, {
                headers: headers
            });
            // calling Api both endpoints 1st for getting user details & 2nd for getting use profile image
            axios.all([getUserData, getUserProfile]).then(
                    axios.spread((...responses) => {
                        const response_for_userData = responses[0];
                        const response_for_userProfileImg = responses[1];
                        let userData = response_for_userData.data;
                        let userProfileData = response_for_userProfileImg.data || {};
                        // console.log(response_for_userProfileImg)
                        // console.log("==>", response_for_userData)
                        // other data
                        if (userData.status !== "error") {
                            userObj = {...userData.user, isAuth: true, isLoading: false }

                        } else {
                            userObj = { isAuth: false, isLoading: false }
                            console.log("Error about checking sign in  user");
                        }
                        // profile Img
                        if (userProfileData.status !== "error") {
                            userObj = {...userObj, profileImg: userProfileData.picture.url ? api_domain + userProfileData.picture.url : "." }
                        } else {
                            userObj = {...userObj, profileImg: {} }
                            console.log("Error about getting user profile");
                        }
                        dispatch({ type: "currentUser", payload: userObj })
                        otherFunc && otherFunc();
                    })
                )
                .catch(errors => {
                    dispatch({ type: "currentUser", payload: userObj })
                    const error_for_userData = errors[0];
                    const error_for_userProfileImg = errors[1];
                    console.log(error_for_userData)
                    console.log(error_for_userProfileImg)
                });
        } else {
            dispatch({ type: "currentUser", payload: userObj })
        }
    }
};

//================ This function is for getting all users List ========================= 
//===========  this is currently not in used ===========
const get_all_users_data = () => {
    return (dispatch) => {
        axios({
            method: "GET",
            url: api_users,
        }).then((response) => {
            let data = response.data;
            if (data.status !== "error") {
                dispatch({ type: "setAllUsers", payload: data.list })
                    // console.log("=====> All users ", data.list)
            } else {
                dispatch({ type: "setAllUsers", payload: {} })
                console.log("Error about getting the list of users ====>", data);
            }
        }).catch((err) => {
            console.log("Error about getting the list of users ====>", err.message);
        })
    }
};

//=================== TO logout user ===========================
const logout_user = () => {
    return (dispatch) => {
        localStorage.removeItem('cyan_user');
        dispatch({ type: "currentUser", payload: {} })
    }
};

export {
    check_current_user,
    logout_user,
    get_all_users_data
};